import React, { FC } from 'react'
import s from './QuickSearchPlaceItem.module.sass'
import ContentLoader from 'react-content-loader'
import {
  SKELETON_FOREGROUND_COLOR,
  SKELETON_MAIN_COLOR,
  SKELETON_SPEED,
  SKELETON_STYLES,
} from '@shared/consts/skeleton'

const Skeleton: FC = () => {
  return (
    <div className={s['skeleton-item-block']}>
      <ContentLoader
        speed={SKELETON_SPEED}
        backgroundColor={SKELETON_MAIN_COLOR}
        foregroundColor={SKELETON_FOREGROUND_COLOR}
        style={SKELETON_STYLES}
        width={82}
        height={20}>
        <rect x='0' y='0' rx='6' ry='6' width={82} height={20} />
      </ContentLoader>

      <ContentLoader
        speed={SKELETON_SPEED}
        backgroundColor={SKELETON_MAIN_COLOR}
        foregroundColor={SKELETON_FOREGROUND_COLOR}
        style={SKELETON_STYLES}
        width={132}
        height={18}>
        <rect x='0' y='0' rx='6' ry='6' width={132} height={18} />
      </ContentLoader>
    </div>
  )
}

export default Skeleton
